import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button } from '@toasttab/buffet-pui-buttons'
import { Layout } from '../../Layout/Layout'
import { useLoyaltyContext } from '../../context/LoyaltyContext'
import { t } from '@local/translations'

export const Successful = () => {
  const { resetLookup, resetSignup } = useLoyaltyContext()
  const navigate = useNavigate()
  const { shortUrl } = useParams<{ shortUrl?: string }>()

  return (
    <Layout>
      <output
        className='font-bold type-headline-5 flex justify-center'
        aria-live='polite'
        aria-atomic='true'
      >
        {t('successful.lookup.message-sent')}
      </output>
      <div className='flex justify-center'>
        {t('successful.lookup.check-inbox')}
      </div>
      <Button className='md:w-1/3' onClick={() => resetLookup()} size='auto'>
        {t('successful.lookup.look-up-account')}
      </Button>

      <Button
        className='w-1/3 text-link'
        onClick={() => {
          resetSignup()
          navigate(`/${shortUrl}/rewardsSignup`)
        }}
        variant='link'
      >
        {t('successful.lookup.sign-up')}
      </Button>
    </Layout>
  )
}
